import type React from 'react'
import { groupDependentFields } from '../../common/utils'
import { formatFieldWithKeys } from '../../selectors/RiskAssessments'
import FormFields from './FormFields'

interface FormProps {
  formId: string
  fields: Record<string, any>
  form: any
  readOnly?: boolean
  style?: React.CSSProperties
  noLeftMargin?: any
  required?: any
  testId?: string
}

const Form: React.FC<FormProps> = ({
  formId,
  fields,
  form,
  testId,
  ...props
}) => {
  const withKeys = form.map(formatFieldWithKeys)
  const formFields = groupDependentFields(withKeys)
  return (
    <FormFields
      userGenerated
      // @ts-ignore
      form={{ formFields }}
      formId={formId}
      fields={fields}
      type="userGenerated"
      testId={testId}
      {...props}
    />
  )
}

export default Form
